import { IStepByIdRespDto, IStepForm } from 'src/types/step.type'

const generateFormState = (step: IStepByIdRespDto, code?: string): IStepForm => ({
  name: step.name,
  description: step.description,
  code: code ?? step.code,
  image: {
    icon: step.image || '',
    file: null,
  },
  image_small: step.image_small,
  image_medium: step.image_medium,
  media: step.media.map((media) => ({ ...media, file: null })),
  selectedImpacts: step.impact_options.map((item) => ({
    id: item.impact_id,
    home_page_show: item.home_page_show,
    impact_page_show: item.impacts_page_show,
    journey_page_show: item.journey_page_show,
  })),
  selectedAccount: step.account_connection?.account?.id
    ? {
        id: step.account_connection?.account?.id,
        landing_page_show: step.account_connection.landing_page_show,
      }
    : null,
  selectedScanners: step.scanners_connections.map((scanner) => scanner.id),
  locations:
    !step?.locations || step?.locations?.length === 0
      ? [
          {
            location_name: '',
            location_address: '',
            latitude: 0,
            longitude: 0,
            radius: 50,
          },
        ]
      : step.locations.map((location) => {
          return {
            id: location?.id || null,
            location_name: location.location_name,
            location_address: location.location_address,
            latitude: location.latitude,
            longitude: location.longitude,
            radius: location.radius,
          }
        }),
})

export { generateFormState }
